<template>
  <v-row>
    <v-col cols="12" class="text-h6">
      {{label}}
    </v-col>
    <v-col cols="6">
      <v-menu
          v-model="dateMenu"
          :close-on-content-click="false"
          max-width="290"
          offset-y
          bottom
      >
        <template v-slot:activator="{ attrs }">
          <v-text-field
              class="mt-0 pt-0"
              v-model="dateInput"
              clearable
              :label="$t('date') + ' (TT.MM.JJJJ)'"
              v-bind="attrs"
              :rules="[rules.date]"
              @click:clear="clearDate"
              @blur="parseDateInput"
          >
            <template v-slot:prepend>
              <v-icon v-bind="attrs" @click="dateMenu = !dateMenu">
                mdi-calendar
              </v-icon>
            </template>
          </v-text-field>
        </template>
        <v-date-picker
            v-model="date"
            @change="dateSelectedFromPicker"
            @input="dateMenu = false"
        ></v-date-picker>
      </v-menu>
    </v-col>
    <v-col cols="6">
      <v-menu
          ref="menu"
          v-model="timeMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          bottom
          max-width="290px"
          min-width="290px"
      >
        <template v-slot:activator="{ attrs }">
          <v-text-field
              class="mt-0 pt-0"
              v-model="time"
              :label="$t('Time') + ' (HH:MM)'"
              v-bind="attrs"
              :rules="[rules.time]"
              @blur="inputChanged"
          >
            <template v-slot:prepend>
              <v-icon v-bind="attrs" v-on:click="timeMenu = !timeMenu">
                mdi-clock-time-four-outline
              </v-icon>
            </template>
          </v-text-field>
        </template>
        <v-time-picker
            v-if="timeMenu"
            v-model="time"
            format="24hr"
            full-width
            @click:minute="timeMenu = false"
            @change="inputChanged"
        ></v-time-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import {format, parse, parseISO, isValid} from "date-fns";

export default {
  name: "DateTimePicker",
  props: {
    value: {
      required: true,
    },
    label: {
      type: String,
      required: true,
    }
  },
  // Das fehlerhafte label: { type: String } wurde hier entfernt
  data() {
    return {
      dateMenu: false,
      timeMenu: false,
      date: null,
      time: '',
      dateInput: '',
      rules: {
        date: value => {
          if (!value) return true;
          const parsed = parse(value, 'dd.MM.yyyy', new Date());
          return isValid(parsed) || 'Ungültiges Datum (TT.MM.JJJJ)';
        },
        time: value => {
          if (!value) return true;
          const pattern = /^([01]\d|2[0-3]):([0-5]\d)$/;
          return pattern.test(value) || 'Ungültige Zeit (HH:mm)';
        }
      }
    }
  },
  methods: {
    // ... existing code ...
    clearDate() {
      this.date = null
      this.dateInput = ''
      this.inputChanged()
    },
    dateSelectedFromPicker() {
      if (this.date) {
        const parsed = parse(this.date, 'yyyy-MM-dd', new Date());
        this.dateInput = format(parsed, 'dd.MM.yyyy');
      }
      this.inputChanged();
    },
    parseDateInput() {
      if (!this.dateInput) {
        this.date = null;
      } else {
        const parsed = parse(this.dateInput, 'dd.MM.yyyy', new Date());
        if (isValid(parsed)) {
          this.date = format(parsed, 'yyyy-MM-dd');
        }
      }
      this.inputChanged();
    },
    inputChanged() {
      // Validierung für den internen Check
      const isDateValid = this.dateInput ? isValid(parse(this.dateInput, 'dd.MM.yyyy', new Date())) : false;
      const isTimeValid = /^([01]\d|2[0-3]):([0-5]\d)$/.test(this.time);

      if (!this.date || !this.time || !isDateValid || !isTimeValid) {
        // Wenn etwas ungültig ist, emittieren wir null statt undefined, das ist oft sicherer
        if (this.value !== null) {
          this.$emit('input', null);
        }
      } else {
        try {
          const dateTime = parse(this.date + ' ' + this.time, 'yyyy-MM-dd HH:mm', new Date()).toISOString();
          if (this.value !== dateTime) {
            this.$emit('input', dateTime);
          }
        } catch (e) {
          this.$emit('input', null);
        }
      }
    },
    valueChanged() {
      if (this.value) {
        const parsed = parseISO(this.value);
        this.date = format(parsed, 'yyyy-MM-dd');
        this.time = format(parsed, "HH:mm");
        this.dateInput = format(parsed, 'dd.MM.yyyy');
      } else {
        this.date = null;
        this.time = '';
        this.dateInput = '';
      }
    }
  },
  watch: {
    value: {
      handler() {
        this.valueChanged();
      },
      immediate: true
    }
  }
}
</script>
